// extracted by mini-css-extract-plugin
export default {"header":"header-m9CGZ9U2","date":"date-zTcVvKpF","version":"version-nikYWEcA","body":"body-zOT04VYD"};